import React, { useState, useEffect } from 'react';
import { Box, Checkbox, FormControl, FormGroup } from '@material-ui/core';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { useStyles } from './FilterOptions.style';
import { nanoid } from 'nanoid';

const FiltersInstitutionsOptions = (props) => {
  const classes = useStyles();

  const [institutionWithRules, setInstitutionWithRules] = useState([]);

  useEffect(() => {
    const inst_list = {};
    props.items.forEach(inst => {
      let newValue = inst;
      if (inst in props.rules) {
        newValue = props.rules[inst];
      }
      if (newValue in inst_list) {
        inst_list[newValue].push(inst);
      } else {
        inst_list[newValue] = [inst];
      }
    });
    setInstitutionWithRules(inst_list);
  }, [props.items, props.rules]);

  const isChecked = (inst) => {
    const aliasesSet = new Set(institutionWithRules[inst].map(x => x.toLowerCase()));
    return props.selected.some(selectedValue => aliasesSet.has(selectedValue.toLowerCase()));
  };

  return (
    <>
      <Box sx={{ display: 'flex' }} key={nanoid()}>
        <FormControl
          sx={{ m: 3 }}
          component='fieldset'
          variant='standard'
          className={classes.formControl}
        >
            <FormGroup key={nanoid()} className={classes.optionsGridContainer_medium}>
              {Object.keys(institutionWithRules).map(inst => (
                <Box key={nanoid()} sx={{ mb: 1 }}>
                  <FormControlLabel
                    className={classes.checkboxLabels}
                    key={nanoid()}
                    label={inst}
                    control={
                      <Checkbox
                        size={'small'}
                        name={inst}
                        checked={isChecked(inst)}
                        onChange={e => props.onChange(institutionWithRules[inst], e.target.checked)}
                        className={classes.checkboxLabels}
                      />
                    }
                  />
                  {institutionWithRules[inst].length > 1 || (institutionWithRules[inst].length === 1 && institutionWithRules[inst][0] !== inst) ? (
                    <Box sx={{ paddingLeft: 4, mt: 0.5 }}>
                      <Box component="ul" sx={{ margin: 0, paddingLeft: 2, listStyle: 'disc' }}>
                        {institutionWithRules[inst].map(originalInst => (
                          <Box 
                            component="li" 
                            key={originalInst}
                            sx={{ 
                              fontSize: '0.75rem', 
                              color: 'text.secondary',
                              mb: 0.3,
                              lineHeight: 1
                            }}
                          >
                            {originalInst.trim()}
                          </Box>
                        ))}
                      </Box>
                    </Box>
                  ) : null}
                </Box>
              ))}
            </FormGroup>
        </FormControl>
      </Box>
    </>
  );
};

FiltersInstitutionsOptions.displayName = 'FiltersInstitutionsOptions';
export default FiltersInstitutionsOptions;
